export enum SUBSCRIPTION_STATUS_ENUM {
  NO_SUBSCRIPTION = "NO_SUBSCRIPTION",
  TRIALING = "TRIALING",
  ACTIVE = "ACTIVE",
  CANCEL_PENDING = "CANCEL_PENDING",
  PAST_DUE = "PAST_DUE",
  UNPAID = "UNPAID",
  CANCELED = "CANCELED",
}

export type SUBSCRIPTION_INVOICE_STATUS =
  | "draft"
  | "open"
  | "paid"
  | "uncollectible"
  | "void";

export type SUBSCRIPTION_INVOICE_COLLECTION_METHOD =
  | "charge_automatically"
  | "send_invoice";
